module.exports = __webpack_public_path__ + "static/media/2usd.f0e29e7c.jpg";